export enum VERCEL_ENVS {
  PRODUCTION = "production",
  PREVIEW = "preview",
  DEVELOPMENT = "development",
}
